import * as React from 'react';

import './AuthenticationError.scss';

import LinkButton from 'common/components/core/Link/LinkButton';
import Icons from 'common/icons';

/**
 * The AuthenticationError component.
 *
 * A view displayed whenever there is an authentication error redirect from IMG.
 */

enum ImgAuthErrors {
  AUTHENTICATION_ISSUE = 'failed_external_authentication',
  INVALID_AUTH_PROVIDER = 'invalid_authentication_provider',
  INTERNAL_ERROR = 'internal_error',
  PARAMETER_ERROR = 'missing_or_wrong_parameter',
  NOT_ALLOWED_AUTH_PROVIDER = 'not_allowed_authentication_provider',
}

enum ImgAuthFlows {
  AUTHENTICATION = 'authentication',
  STORAGE = 'storage',
}

export default class AuthenticationError extends React.PureComponent {
  private parseErrorParams = (): string => {
    const searchParams = new URLSearchParams(window.location.search);
    const authError = searchParams.get('error');
    const authFlow = searchParams.get('flow');

    switch (authError) {
      case ImgAuthErrors.AUTHENTICATION_ISSUE:
        return 'NC2 had trouble authenticating you. A failure occurred while communicating with your identity provider.';
      case ImgAuthErrors.INVALID_AUTH_PROVIDER:
        return "NC2 had trouble authenticating you. That identity provider doesn't exist. Please check for typos or contact your administrator.";
      case ImgAuthErrors.INTERNAL_ERROR:
        return 'NC2 had trouble authenticating you. This identity provider may be misconfigured or is inaccessible.';
      case ImgAuthErrors.PARAMETER_ERROR:
        return 'NC2 had trouble authenticating you. The request is missing required information.';
      case ImgAuthErrors.NOT_ALLOWED_AUTH_PROVIDER:
        if (authFlow === ImgAuthFlows.STORAGE) {
          return "NC2 couldn't access your storage account. Please double-check your storage provider's settings and try again later.";
        }
        return 'This relying party is unauthorized for use with your identity provider. Please double-check configurations or contact support.';

      default:
        return 'NC2 had trouble authenticating you. Please reach out to your administrator for assistance.';
    }
  };

  public render() {
    const message = this.parseErrorParams();
    return (
      <div className="authentication-error onboarding">
        <div className="onboarding-box">
          <div className="authentication-error__description">{message}</div>

          <LinkButton className="accept-button" href="/">
            Go Home
          </LinkButton>

          <img className="onboarding-box__logo" src={Icons.NUTANIX_TYPE_LIGHT} alt="Nutanix" />
        </div>
      </div>
    );
  }
}
